export const regex: any = {
	BdPhone: /^(?:\+?88)?0?1[3-9]\d{8}$/g,
	name: "([a-zA-Z]{3,30}s*)+",
	designation: "^s*[a-zA-Z.s]+s*$",
	companyName: "^[A-Z]([a-zA-Z0-9]|[- @.#&!])*$",
}
